// extracted by mini-css-extract-plugin
export var body = "_lf-0";
export var sectionHeader = "_lf-4";
export var shortcutColumns = "_lf-2";
export var shortcutList = "_lf-1";
export var shortcutSection = "_lf-3";